export const products = [
  // { id: 1, name: 'કપાસ', image: '/Images/x port 1.png', category: [{ image: '/Images/x port 1.png', title: 'એક્સપોર્ટ BGll', title2: 'સંશોધીત હા. કપાસ બીજ', titleColor: "#0084BF", content: ["૬ થી ૭ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ", "૧૬૦ થી ૧૭૫ દિવસે પાકતી જાત", "જીંડવાનું કદ અંદાજીત ૫ થી ૬ ગ્રામ", "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક", "૧૦ થી ૧૫ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો", "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિતપિયત માટે ૪ X ૨ ફુટ"] }] },
  {
    id: 1,
    name: "કપાસ",
    image: "/Images/x port 1.png",
    bannerImage: "/Images/Product-banner.png",
    bannerTitle: `કપાસના ઉત્તમ બીજ ખરીદો - <br/> ઉત્તમ ઉપજ સાથે ગુણવત્તામાં કોઈ સમજૂતી નહીં!`,
    headingTitle: "મંતવ્યા સીડ્સ કપાસ ના બિયારણ બિયારણ",
    imageGroup: [
      "/Images/product-d-image1.png",
      "/Images/product-d-image2.png",
      "/Images/product-d-image3.png",
      "/Images/product-d-image4.png",
      "/Images/product-d-image5.png",
      "/Images/product-d-image6.png",
    ],
    category: [
      {
        image: "/Images/x port 1.png",
        title: "એક્સપોર્ટ BGll",
        title2: "સંશોધીત હા. કપાસ બીજ",
        titleColor: "#0084BF",
        content: [
          "૬ થી ૭ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ",
          "૧૬૦ થી ૧૭૫ દિવસે પાકતી જાત",
          "જીંડવાનું કદ અંદાજીત ૫ થી ૬ ગ્રામ",
          "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક",
          "૧૦ થી ૧૫ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો",
          "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિતપિયત માટે ૪ X ૨ ફુટ",
        ],
      },
      {
        image: "/Images/x-cross-1.png",
        title: "ઝેડપ્લસ BGll",
        title2: "સંશોધીત હા. કપાસ બીજ",
        titleColor: "#D20309",
        content: [
          "૫ થી ૬ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ",
          "૧૬૦ થી ૧૭૫ દિવસે પાકતી જાત",
          "જીંડવાનું કદ અંદાજીત ૬ થી ૬.૫ ગ્રામ",
          "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક",
          "૧૦ થી ૧૫ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો",
          "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિતપિયત માટે ૪ X ૨ ફુટ",
        ],
      },
      {
        image: "/Images/z-plus-1.png", // Add the correct path for the image
        title: "ઝેડ ક્રોસ BGll",
        title2: "સંશોધીત હા. કપાસ બીજ",
        titleColor: "#7E317D", // Adjust color as seen in the image
        content: [
          "૬ થી ૭ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ",
          "૧૬૦ થી ૧૭૫ દિવસે પાકતી જાત",
          "જીંડવાનું કદ અંદાજીત ૫ થી ૬ ગ્રામ",
          "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક",
          "૧૦ થી ૧૫ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો",
          "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિતપિયત માટે ૪ X ૨ ફુટ",
        ],
      },
      {
        image: "/Images/mantavya06-1.png", // Add the correct path for the image
        title: "મંતવ્ય-5 BGll",
        title2: "સંશોધીત હા. કપાસ બીજ",
        titleColor: "#79AF37", // Adjust color as seen in the image
        content: [
          "૫.૫ થી ૭ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ",
          "૧૬૫ થી ૧૭૫ દિવસે પાકતી જાત",
          "જીંડવાનું કદ અંદાજીત ૫.૫ થી ૬.૫ ગ્રામ",
          "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક",
          "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિત પિયત માટે ૪ X ૨ ફુટ",
          "૧૦ થી ૧૩ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "મગફળી",
    image: "/Images/magfadi-main-image.jpg",
    bannerImage: "/Images/Product-banner.png",
    bannerTitle: `ઉત્તમ મગફળીના બીજ - વધુ ઉત્પાદન, વધુ નફો!`,
    headingTitle: "મંતવ્ય સીડ્સ મગફળી નું બિયારણ",
    imageGroup: [
      "/Images/magfadi-image-group1.png",
      "/Images/magfadi-image-group2.png",
      "/Images/magfadi-image-group3.png",
      "/Images/magfadi-image-group4.png",
      "/Images/magfadi-image-group5.png",
      "/Images/magfadi-image-group6.png",
    ],
    category: [
      {
        image: "/Images/magfadi-main-image.jpg",
        title: "મંતવ્ય રાહી",
        title2: "સંશોધીત મગફળી  બીજ",
        titleColor: "#CCAA60",
        content: [
          "અર્ધ વેલડી પ્રકારની ચોમાસું વાવેતર માટે યોગ્ય જાત",
          "પાકવાના દિવસો લગભગ ૧૧૦ થી ૧૨૦",
          "સુષુપ્તાવસ્થા લગભગ ૪૫ દિવસ",
          "૧૦૦ દાણાનું વજન ૭૯ થી ૮૧ ગ્રામ",
          "આછા ગુલાબી રંગના મોટા દાણા હોવાથી સૌથી ઉંચા બજાર ભાવ",
        ],
      },
    ],
  },
  {
    id: 3,
    name: "દિવેલા",
    image: "/Images/kanam 1.png",
    bannerImage: "/Images/divela/image 3.png",
    bannerTitle: `ઉત્તમ દિવેલાના બીજ - વધુ ઉત્પાદન, વધુ નફો!`,
    headingTitle: "મંતવ્ય સીડ્સ દિવેલા નું બિયારણ",
    imageGroup: [
      "/Images/divela/arnda-new-3.png",
      "/Images/divela/castor-king-amul-field.png",
      "/Images/divela/b1a3c66e-2fb9-494a-b3c1-85a1d5fb707a.png",
      "/Images/divela/1-s2.0-S0961953407001481-gr1.png",
      "/Images/divela/IMG-20210916-WA0009 - Copy.png",
      "/Images/divela/Castor-seeds1.png",
    ],
    category: [
      {
        image: "/Images/kanam 1.png",
        title: "મંતવ્ય રાહી દિવેલા",
        title2: "સંશોધીત દિવેલા બીજ",
        titleColor: "#23719e",
        content: [
          " લીલા રંગનો ત્રણછારી વાળો છોડ",
          " આશરે ૧૭૦ થી ૧૯૦ દિવસમાં પાકતી જાત",
          "૫૦ થી ૫૫ દિવસમાં પ્રથમ માળ અને કાપણી ૧૦૫ થી ૧૧૦ દિવસ આસપાસ",
          " હલ્કી તથા રેતાળ જમીન માટે અનુકુળ",
          " ૧૦૦૦ દાણાનું વજન આશરે ૨૮૦ થી ૩૦૦ ગ્રામ",
          "વધુ ડાળીઓ, લાંબી ભરાવદાર માળો હોવાથી વધુ",
        ],
      },
      {
        image: "/Images/divela/mantavya savaj-11 1.png",
        title: "મંતવ્ય સાવજ",
        title2: "સંશોધીત હા. દિવેલા બીજ",
        titleColor: "#5A3980",
        content: [
          "૫ થી ૬ ફુટ ઉંચાઈ વાળો મજબુત ખુલ્લા પ્રકારનો છોડ",
          " ૧૬૦ થી ૧૭૫ દિવસે પાકતી જાત",
          "જીંડવાનું કદ અંદાજીત ૬ થી ૬.૫ ગ્રામ",
          "ચુસિયા અને જીંડવાની ઈયળ સામે પ્રતિકારક",
          "૧૦ થી ૧૫ ફળાઉ ડાળીયો તથા ૨ થી ૩ બીન ફળાઉ ડાળીયો",
          "વાવેતર અંતર પિયત માટે ૫ X ૩ ફુટ તથા મર્યાદિતપિયત માટે ૪ X ૨ ફુટ",
        ],
      },
      {
        image: "/Images/divela/mantavya 44 1.png",
        title: "મંતવ્ય 44",
        title2: "હાઈબ્રીડ દિવેલા બીજ ",
        titleColor: "#5E334F",
        content: [
          "મધ્યમ ઉંચાઈ ધરાવતો મેહાગોની પ્રકારનો ત્રણ છારીવાળો છોડ",
          "વધુ પેટા ડાળીયો હોવાથી પ્રત્યેક છોડ ઉપર સરેરાશ ૧૫ થી ૧૮ની સંખ્યામાં મોટી તથા ઘટ્ટ માળો",
          "સુકારા સામે તથા ચુસિયા પ્રકારની જીવાત સામે પ્રતિકારક શક્તિ",
          "જમીન તથા પાણીની સગવડ પ્રમાણે આશરે ૧૮૦ થી ૨૧૦ દિવસમાં પાકતી જાત",
          "પિયત વિસ્તાર માટે વધુ અનુકૂળ તથા ઓછા પિયતમાં અન્ય જાતો કરતાં વધુ ઉત્પાદન",
          "વાવેતર અંતર : પિયત ૬ X ૪ ફુટ અને બિનપિયત ૪ X ૩ ફુટ",
        ],
      },
      {
        image: "/Images/divela/mantavya 66 1.png",
        title: "મંતવ્ય 66",
        title2: "સંશોધીત હા. દિવેલા બીજ",
        titleColor: "#5A3980",
        content: [
          "લીલા રંગનો દ્વિછારીય છોડ.",
          " અંદાજીત ૧૮૦ થી ૨૦૦ દિવસમાં પાકતી જાત.",
          "બિનપિયત વિસ્તાર અને હલ્કી તથા રેતાળ જમીન માટે વધુ અનુકૂળ જાત.",
          "વધારે ડાળીઓ તથા ભરાવદાર લાંબી માળો હોવાથી વધારે ઉત્પાદન આપતી જાત.",
          " ૧૦૦૦ દાણાનું વજન આશરે ૨૯૦ થી ૩૧૦ ગ્રામ.",
          " તેલની માત્રા ૫૧ થી ૫૩ ટકા હોવાથી વધુ ઉત્પાદન.",
          "વાવેતર અંતર:- પિયત વિસ્તાર - ૬ ફુટ x ૪ ફુટ.",
          "બિનપિયત વિસ્તાર - ૫ ફુટ x ૩ ફુટ.",
        ],
      },
    ],
  },
  {
    id: 4,
    name: "તલ",
    image: "/Images/mantavya 111 1.png",
    bannerImage: "/Images/tal/image 4.png",
    bannerTitle: `તલના ગુણવત્તાવાળા બીજ - વધારે તેલ, વધારે નફો!`,
    headingTitle: "મંતવ્ય સીડ્સ તલ નું બિયારણ",
    imageGroup: [
      "/Images/tal/talimagegroup1.png",
      "/Images/tal/talimagegroup2.png",
      "/Images/tal/talimagegroup3.png",
      "/Images/tal/talimagegroup4.png",
      "/Images/tal/talimagegroup5.png",
      "/Images/tal/talimagegroup6.png",
    ],
    category: [
      {
        image: "/Images/mantavya 111 1.png",
        title: "મંતવ્ય 111",
        title2: "સંશોધીત તલ(બ્લેક) બીજ",
        titleColor: "#15415A",
        content: [
          "વધુ ડાળીઓ ધરાવતો તથા ૧૧૦ થી ૧૨૦ સે.મી. ઉંચાઈવાળો છોડ",
          "૯૫ થી ૧૦૫ દિવસમાં પાકતી જાત",
          "ફુલનો રંગ સફેદ",
          "મધ્યમ મોટા કદના તથા ચમકદાર દાણા, ૧૦૦૦ દાણાનું વજન ૩૦ થી ૩૨ ગ્રામ",
          "  તેલની ટકાવારી આશરે ૪૫ થી ૪૭ ટકા",
          "૮૦ થી ૯૦ની સંખ્યામાં લાગતા મધ્યમ લાંબા ડીંડવા તથા ડીંડવા પાકવા પછી પણ ફાટતા નથી",
        ],
      },
      {
        image: "/Images/tal/MANTAVYA keshav 1.png",
        title: "મંતવ્ય કેશવ",
        title2: "સંશોધીત તલ બીજ",
        titleColor: "#4946A0",
        content: [
          "૪ થી ૮ ડાળીઓ ધરાવતો છોડ, ૯૦ થી ૧૦૦ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "એક્ષપોર્ટ કરવા લાયક મધ્યમ મોટા ટીનોપાલ સફેદી ધરાવતા દાણા",
          "૮૦ થી ૯૦ દિવસના ગાળામાં જલ્દી પાકતી જાત",
          "પ્રત્યેક ડાળીએ શરૂઆતથી જ ડોડવા લાગતા હોવાથી ઉંચુ ઉત્પાદન",
          "દાણામાં ૫૦ થી ૫૧ ટકા સુધી તેલની ટકાવારી",
          "ઉનાળું તેમજ ચોમાસા માટે વાવણી લાયક",
        ],
      },
      {
        image: "/Images/tal/18 1.png",
        title: "મંતવ્ય એમ એસ-05",
        title2: "સંશોધીત તલ બીજ",
        titleColor: "#DF289D",
        content: [
          "૧૧૦ થી ૧૨૫ સે.મી ઉંચાઈવાળો સોટીયા પ્રકારનો છોડ",
          "શાખાઓ ઉપર એક જગ્યાએ પુરા ચક્કરમાં લાગતા ૪ થી ૬ ડોડવા",
          "એક છોડ ઉપર અંદાજીત ૧૦૦ થી વધારે નીચેથી શરૂ થતા ડોડવા",
          "સફેદ રંગના આકર્ષક મોટા દાણા, તેલની માત્રા અંદાજીત ૪૯ થી ૫૧ ટકા",
          "પાકવાની અવધિ લગભગ ૮૫ થી ૯૫ દિવસ",
          "ઉનાળુ તેમજ ચોમાસા માટે વાવણી લાયક",
          "ફાયલોડી તથા બેક્ટેરીયલ બ્લાઈટ રોગના સામે સહનશીલ જાત્",
        ],
      },
      {
        image:
          "/Images/tal/WhatsApp_Image_2024-01-12_at_10.28.51_AM__1_-removebg-preview 1.png",
        title: "મંતવ્ય એમ એસ-18",
        title2: "સંશોધીત તલ બીજ",
        titleColor: "#8D4F27",
        content: [
          "૧૧૫ થી ૧૩૦ સે.મી ઉંચાઈવાળો શાખાયુક્ત છોડ",
          " શાખાઓ ઉપર એક જગ્યાએ પુરા ચક્કરમાં લાગતા ૪ થી ૮ ડોડવા",
          "બૈઠા મોટી સાઈઝના અને રૂવાટી વગરના",
          "એક છોડ ઉપર અંદાજીત ૧૦૦ થી વધારે નીચેથી શરૂ થતા ડોડવા",
          "સફેદ રંગના આકર્ષક મોટા દાણા, તેલની માત્રા અંદાજીત ૪૮ થી ૫૧ ટકા",
          "પાકવાની અવધિ લગભગ ૯૦ થી ૧૦૦ દિવસ",
          "ઉનાળુ તેમજ ચોમાસા માટે વાવણી લાયક",
          "ફાયલોડી તથા બેક્ટેરીયલ બ્લાઈટ રોગના સામે સહનશીલ જાત",
        ],
      },
      {
        image: "/Images/tal/ms60 2.png",
        title: "મંતવ્ય એમ એસ-60",
        title2: "સંશોધીત તલ બીજ",
        titleColor: "#DF289D",
        content: [
          "ઉનાળુ તેમજ ચોમાસુ માટે વાવણી લાયક",
          "૬૫ થી ૭૦ દિવસના ગાળામાં પાકતી જાત",
          "૪૮ થી ૫૦ ટકા સુધી તેલની ટકાવારી",
          "૮૫ થી ૯૫ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "સફેદ રંગના આકર્શક દાણા",
        ],
      },
    ],
  },
  {
    id: 5,
    name: "મગ",
    image: "/Images/mantavya mohak 1.png",
    bannerImage: "/Images/mag/magbanner.png",
    bannerTitle: `ઉચ્ચ ગુણવત્તાવાળા મગના બીજ વધુ ઉત્પાદન અને શ્રેષ્ઠ ઉપજ માટે`,
    headingTitle: "મંતવ્ય સીડ્સ મગ ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/mag/maggroup1.png",
      "/Images/mag/maggroup2.png",
      "/Images/mag/maggroup3.png",
      "/Images/mag/maggroup4.png",
      "/Images/mag/maggroup5.png",
      "/Images/mag/maggroup6.png",
    ],
    category: [
      {
        image: "/Images/mag/65 1.png",
        title: "મંતવ્ય 65",
        title2: "સંશોધીત મગ બીજ",
        titleColor: "#615A35",
        content: [
          "આશરે ૫૦ થી ૭૫ સે.મી. ની મધ્યમ ઉંચાઈ ધરાવતો છોડ",
          "૬૦ થી ૬૫ દિવસના ગાળામાં ૫૦% ફુલ અવસ્થા તથા ૭૦ થી ૭૫ દિવસે પાકતી જાત",
          "છોડની શરૂઆતના ભાગથી ૧૦ થી ૧૩ ની સંખ્યામાં ઝુમખામાં લાગતી શીંગો",
          "પીળા રંગના ફુલ ધરાવતા તથા ૩ થી ૪ ની સંખ્યામાં મુખ્ય ડાળીઓ ધરાવતા છોડ",
          "સરેરાશ ૮ થી ૧૦ સે.મી. લાંબી શીંગો અને દાણાની સંખ્યા ૧૦ થી ૧૨",
        ],
      },
      {
        image: "/Images/mag/mohak 1.png",
        title: "મંતવ્ય મોહક",
        title2: "સંશોધીત મગ બીજ",
        titleColor: "#36434b",
        content: [
          "૧૦ થી ૧૨ ડાળીયુક્ત ફેલાય તેવો તથા ૫૦ થી ૬૫ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "ઝુમખામાં લાગતી તથા એક સાથે પાકતી શીંગો",
          "પીળી નસના મોજેક રોગ સામે સહનશીલ જાત",
          "ચોમાસુ તથા ઉનાળુ ઋતુ માટે વાવણી લાયક જાત",
          "૭૫ થી ૮૫ દિવસના ગાળામાં પાકતી જાત",
          "ચમકતા લીલા રંગના મધ્યમ મોટા દાણા હોવાથી ઉંચો બજાર ભાવ",
        ],
      },
      {
        image: "/Images/mag/sagar 1.png",
        title: "મંતવ્ય સાગર",
        title2: "સંશોધીત મગ બીજ",
        titleColor: "#C7263C",
        content: [
          " ૧૧ થી ૧૨ ડાળીયુક્ત ફેલાય તેવો તથા ૪૫ થી ૬૦ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "૭૦ થી ૮૦ દિવસના ગાળામાં પાકતી જાત",
          "ચમકતા લીલા રંગના મધ્યમ મોટા દાણા હોવાથી ઉંચો બજાર ભાવ",
          " ઝુમખામાં લાગતી તથા એક સાથે પાકતી શીંગો",
          "પીળી નસના મોજેક રોગ સામે સહનશીલ જાત",
          "ચોમાસુ તથા ઉનાળુ ઋતુ માટે વાવણી લાયક જાત",
        ],
      },
    ],
  },
  {
    id: 6,
    name: "અડદ",
    image: "/Images/adad/manthn 1.png",
    bannerImage: "/Images/adad/adadbanner.png",
    bannerTitle: `ઉચ્ચ ગુણવત્તાવાળા અડદના બીજ ખાતરી સાથે વધુ ઉપજ!`,
    headingTitle: "મંતવ્ય સીડ્સ અડદ ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/adad/adadgroup1.png",
      "/Images/adad/adadgroup2.png",
      "/Images/adad/adadgroup3.png",
      "/Images/adad/adadgroup4.png",
      "/Images/adad/adadgroup5.png",
    ],
    category: [
      {
        image: "/Images/adad/manthn 1.png",
        title: "મંતવ્ય મંથન",
        title2: "સંશોધીત અડદ બીજ",
        titleColor: "#dcaf27",
        content: [
          "વિકાસઃ સીજન પ્રમાણે ૨ થી ૨.૫ ફુટ થાય",
          "ફાલઃ ૩૦-૪૦ દિવસમાં શરૂ થાય, એકદમ થડની નજીક લાગે તેમજ ગુચ્છામાં જુસ્સા પૂર્વક લાગે.",
          "સીંગઃ રૂવાટીદાર સીંગ, પ્રતિ છોડ ૫૦-૬૫ સીંગો લાગે અને પ્રતિ સીંગ ૫-૭ દાણાં આવે.",
          "અંતરઃ હાર થી હાર વચ્છે પોણો થી એક ફુટનું અંતર અનુકુળ છે.",
          "સમયઃ ૮૦-૮૫ દિવસમાં પાકે, આંતર પાક તરીકે ઉત્તમ જાત.",
        ],
      },
      {
        image: "/Images/adad/101 1.png",
        title: "મંતવ્ય 101",
        title2: "સંશોધીત અડદ બીજ",
        titleColor: "#403B3A",
        content: [
          "શીંગ પાકવા સુધીમાં ૭૫ થી ૮૫ દિવસમાં પાકતી જાત",
          "અંદાજીત ૬૦ થી ૭૦ સે.મી. ઉંચાઈવાળા રેસારહિત શાખાયુક્ત છોડ",
          "લીસી તથા એક સાથે પાકતી શીંગો અને મોટા, કાળા તથા ચમકીલા દાણા હોવાથી ઉંચો બજાર ભાવ",
          "ફુલ આવવાની શરૂઆત ૩૩ થી ૪૦ દિવસ",
          "૧૦૦ દાણાનું વજન લગભગ ૩.૫ થી ૩.૮ ગ્રામ",
          "પીળીયા રોગ સામે પ્રતિકારક જાત",
        ],
      },
    ],
  },
  {
    id: 7,
    name: "તુવેર",
    image: "/Images/tuver/tuver super@3x 2.png",
    bannerImage: "/Images/tuver/tuverbanner.png",
    bannerTitle: `તુવેરની શ્રેષ્ઠ જાત – વધુ ઉત્પાદન માટે પસંદગી કરો!`,
    headingTitle: "મંતવ્ય સીડ્સ તુવેર ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/tuver/tuvergroup1.png",
      "/Images/tuver/tuvergroup2.png",
      "/Images/tuver/tuvergroup3.png",
      "/Images/tuver/tuvergroup4.png",
      "/Images/tuver/tuvergroup5.png",
    ],
    category: [
      {
        image: "/Images/tuver/tuver super@3x 2.png",
        title: "મંતવ્ય સુપર",
        title2: "સંશોધીત તુવેર બીજ",
        titleColor: "#2a543c",
        content: [
          "૬ થી ૭ ફુટ ઉંચાઈવાળો વધુ ડાળી યુક્ત છોડ",
          "મધ્યમ લાંબી ૪ થી ૬ દાણાવાળી ગુચ્છામાં બેસતી શીંગો",
          "દાણા મોટા, સફેદ અને ચમકદાર હોવાથી વધુ બજાર ભાવ",
          "૧૫૫ થી ૧૬૫ દિવસે પાકતી જાત",
          "પકવવા તેમજ શાકભાજી બન્ને માટે અનુકુળ",
          "સુકારા સામે પ્રતિકારક અને ઉત્પાદન આશરે ૧૨ થી ૧૫ ક્વિંટલ પ્રતિ એકર (આબોહવા અને માવજત ઉપર આધારિત)",
        ],
      },
      {
        image: "/Images/tuver/tuver kuber@3x 1.png",
        title: "મંતવ્ય કુબેર",
        title2: "સંશોધીત તુવેર બીજ",
        titleColor: "#575352",
        content: [
          "છોડની ઉંચાઈ ૫ થી ૬ ફુટ",
          "ખુલ્લો તથા ડાળીવાળો છોડ",
          "દાણાનો રંગ ભુરાશ પડતો લાલ",
          "શીંગ દીઠ દાણાની સંખ્યા ૫ થી ૭",
          "ફુલનો રંગ પીળો",
          "છોડ દીઠ શાખાઓની સંખ્યા ૧૫ થી ૧૭",
          "૧૦૦ દાણાનું વજન ૧૨ થી ૧૪ ગ્રામ",
        ],
      },
    ],
  },
  {
    id: 8,
    name: "રાઈ",
    image: "/Images/rai/MANTAVYA SAMRTH 2.png",
    bannerImage: "/Images/rai/raibanner.png",
    bannerTitle: `તંદુરસ્ત અને ફળદ્રુપ પાક માટે શ્રેષ્ઠ રાઈ બીજ`,
    headingTitle: "મંતવ્ય સીડ્સ રાઈ ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/rai/raibanner.png",
      "/Images/rai/raigroup2.png",
      "/Images/rai/raigroup3.png",
      "/Images/rai/raigroup4.png",
      "/Images/rai/raigroup5.png",
      "/Images/rai/raigroup6.png",
    ],
    category: [
      {
        image: "/Images/rai/MANTAVYA SAMRTH 2.png",
        title: "મંતવ્ય સમર્થ",
        title2: "સંશોધીત રાઈ બીજ",
        titleColor: "#cea622",
        content: [
          "૧૦૦ થી ૧૧૫ દિવસના ગાળામાં પાકતી જાત",
          "૧૦ થી ૧૨ ની સંખ્યામાં મુખ્ય શાખાઓ સાથે ૨૩ થી ૨૫ ઉપશાખાઓ ધરાવતો મધ્યમ ઉંચો છોડ",
          "જાડી તથા ભુરાશ પડતા કાળા રંગની લાંબી શીંગો સાથે મધ્યમ મોટા દાણા",
          "તેલની ટકાવારી ૪૦ થી ૪૨ ટકા",
          "અન્ય જાતોની સરખામણીએ ઉંચું ઉત્પાદન આપતી જાત",
        ],
      },
      {
        image: "/Images/rai/45m45 1.png",
        title: "મંતવ્ય 45 એમ 45",
        title2: "હાયબ્રીડ રાયડો બીજ",
        titleColor: "#006834",
        content: [
          "પિયત અને બિન પિયત વાવેતર માટે યોગ્ય છે.",
          "આ ૧૦૫ થી ૧૧૫ દિવસોમાં પાકતી જાત છે.",
          "છોડ મધ્યમ ઉંચાઇનો ૧૪૦ થી ૧૫૦ સે.મી.",
          "સીંગો મધ્યમ લંબાઇની અને ભરાવદાર હોય છે.",
          "દાણા મોટા, ૧૦૦૦ દાણાનું વજન ૫.૫ થી ૬ ગ્રામ, મધ્યમ ભુરા પડતા કાળા રંગના હોય છે.",
          "બીજમાં તેલનું પ્રમાણ ૪૨ થી ૪૫ ટકા હોય છે.",
        ],
      },
    ],
  },
  {
    id: 9,
    name: "જીરા",
    image: "/Images/jiru/NEW jackpot 1.png",
    bannerImage: "/Images/jiru/jirubanner.png",
    bannerTitle: `શિયાળા સીઝન નું સોનુ એટલે મંતવ્ય જીરા`,
    headingTitle: "મંતવ્ય સીડ્સ જીરા ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/jiru/jirugroup1.png",
      "/Images/jiru/jirugroup2.png",
      "/Images/jiru/jirugroup3.png",
      "/Images/jiru/jirugroup4.png",
      "/Images/jiru/jirugroup5.png",
      "/Images/jiru/jirugroup6.png",
    ],
    category: [
      {
        image: "/Images/jiru/NEW jackpot 1.png",
        title: "જેકપોટ",
        title2: "સંશોધીત જીરા બીજ",
        titleColor: "#78448e",
        content: [
          "આશરે ૧૦૫ થી ૧૧૦ દિવસના ગાળામાં પાકતી જાત.",
          "બીજ વીટાવેક્ષ તથા એસડીએમ પાઉડર થી કોટેડ હોવાથી તથા ફુગ સામે રક્ષણ",
          "૪૫ થી ૫૦ સે.મી ઉંચાઈવાળો સુકારા પ્રતિકારક શક્તિ ધરાવતો છોડ",
          "મુખ્ય ડાળી સાથે વધુ સંખ્યામાં પેટા ડાળીઓ તથા વધુ ફુલ ચક્કર ધરાવતો છોડ હોવાથી ઉંચુ ઉત્પાદન",
          "છોડ ઉપર ૫૦% ફુલ આશરે ૬૦ થી ૬૨ દિવસ પછી જાેવા મળે",
        ],
      },
      {
        image: "/Images/jiru/07 1.png",
        title: "મહાકાલ 07",
        title2: "હાયબ્રીડ જીરા બીજ",
        titleColor: "#1c5f34",
        content: [
          "આશરે ૧૦૦ થી ૧૧૫ દિવસે પાકતી જાત",
          "ફુલ ચક્કરની સંખ્યા અંદાજીત ૧૨ થી ૧૫",
          "ઈમિડાક્લોપ્રીડ તથા વીટાવેક્ષ પાઉડર કોટેડ બીજ",
          "છોડ ઉપર ૫૦% ફુલ આશરે ૫૫ થી ૬૦ દિવસે જાેવા મળે",
          "સુંગધિત તેલની ટકાવારી ઉંચી હોવાથી દાણો વધુ વજનદાર",
          "જમીનજન્ય તથા રસચૂસક જીવાત સામે વધારે પ્રતિકારક",
        ],
      },
      {
        image: "/Images/jiru/MANTAVYA 105 1.png",
        title: "મંતવ્ય 105",
        title2: "સંશોધીત જીરા બીજ",
        titleColor: "#f15a22",
        content: [
          "આશરે ૯૫ થી ૧૦૫ દિવસે પાકતી જાત",
          "ફુલ ચક્કરની સંખ્યા અંદાજીત ૧૦ થી ૧૪",
          "ઈમિડાક્લોપ્રીડ તથા વીટાવેક્ષ પાઉડર કોટેડ બીજ",
          "સુંગધિત તેલની ટકાવારી ઉંચી હોવાથી દાણો વધુ વજનદાર",
          "છોડ ઉપર ૫૦% ફુલ આશરે ૫૦ થી ૬૦ દિવસે જાેવા મળે",
          "જમીનજન્ય તથા રસચૂસક જીવાત સામે વધારે પ્રતિકારક",
        ],
      },
    ],
  },
  {
    id: 10,
    name: "ઘઉં",
    image: "/Images/wheat/14 2.png",
    bannerImage: "/Images/wheat/wheatbanner.png",
    bannerTitle: `સારા ઘઉં, વધુ ઉત્પાદન, ખેડૂતનો ભરપૂર ફાયદો!`,
    headingTitle: "મંતવ્ય સીડ્સ ઘઉં ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/wheat/whaetgroup1.png",
      "/Images/wheat/whaetgroup2.png",
      "/Images/wheat/whaetgroup3.png",
      "/Images/wheat/whaetgroup4.png",
      "/Images/wheat/whaetgroup5.png",
      "/Images/wheat/wheatgroup6.png",
    ],
    category: [
      {
        image: "/Images/wheat/14 2.png",
        title: "મંતવ્ય પંચમ",
        title2: "સંશોધીત ઘઉં બીજ",
        titleColor: "#016435",
        content: [
          "આશરે ૧૦૫ થી ૧૧૦ દિવસના ગાળામાં પાકતી જાત",
          "બીજ વીટાવેક્ષ તથા એસડીએમ પાઉડર થી કોટેડ હોવાથી તથા ફુગ સામે રક્ષણ",
          "૪૫ થી ૫૦ સે.મી ઉંચાઈવાળો સુકારા પ્રતિકારક શક્તિ ધરાવતો છોડ",
          "મુખ્ય ડાળી સાથે વધુ સંખ્યામાં પેટા ડાળીઓ તથા વધુ ફુલ ચક્કર ધરાવતો છોડ હોવાથી ઉંચુ ઉત્પાદન",
          "છોડ ઉપર ૫૦% ફુલ આશરે ૬૦ થી ૬૨ દિવસ પછી જાેવા મળે",
        ],
      },
    ],
  },
  {
    id: 11,
    name: "ઇસબગુલ",
    image: "/Images/isabgul/isabgul mantavya 21 1.png",
    bannerImage: "/Images/isabgul/isabgulbanner.png",
    bannerTitle: `ઉત્તમ ગુણવત્તાની ઇસબગુલ,વધુ ઉપજ અને ખાતરીયુક્ત નફો!`,
    headingTitle: "મંતવ્ય સીડ્સ ઇસબગુલ ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/isabgul/isabgulgroup1.png",
      "/Images/isabgul/isabgulgroup2.png",
      "/Images/isabgul/isabgulgroup3.png",
      "/Images/isabgul/isabgulgroup4.png",
      "/Images/isabgul/isabgulgroup5.png",
    ],
    category: [
      {
        image: "/Images/isabgul/isabgul mantavya 21 1.png",
        title: "મંતવ્ય 21",
        title2: "સંશોધીત ઇસબગુલ બીજ",
        titleColor: "#016435",
        content: [
          "અદાંજીત ૩૫ થી ૪૦ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "અંદાજીત ૧૦૫ થી ૧૧૦ દિવસમાં પાકતી જાત",
          "ડાઉની મીલ્ડ્યુ રોગ સામે પ્રતિકારક જાત",
          "ઉભો છોડ ભરાવદાર ઉંબી",
        ],
      },
    ],
  },
  {
    id: 12,
    name: "વરીયાળી",
    image: "/Images/variyali/101 2.png",
    bannerImage: "/Images/isabgul/isabgulbanner.png",
    bannerTitle: `ખાસ ગુણવત્તાવાળી વરિયાળી,વધુ ઉપજ સાથે ખેડૂત માટેનો વિશ્વાસ.`,
    headingTitle: "મંતવ્ય સીડ્સ વરીયાળી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/variyali/variyaligroup1.png",
      "/Images/variyali/variyaligroup2.png",
      "/Images/variyali/variyaligroup3.png",
      "/Images/variyali/variyaligroup4.png",
      "/Images/variyali/variyaligroup5.png",
      "/Images/variyali/variyaligroup6.png",
    ],
    category: [
      {
        image: "/Images/variyali/101 2.png",
        title: "મંતવ્ય 101",
        title2: "સંશોધીત વરીયાળી બીજ",
        titleColor: "#aa612e",
        content: [
          "ફેરરોપણી ના બદલે સીધા જ વાવેતર માટે ઉપયુક્ત",
          "રવી તથા ખરીફ ઋતુ માટે વાવણી લાયક જાત",
          "ખુલ્લો તથા જુસ્સાદાર છોડ તથા ૧૩૫ થી ૧૪૫ દિવસમાં પાકતી જાત",
          "૧૪૫ થી ૧૬૫ સે.મી. ઉંચો તથા ભરાવદાર દાણાવાળો છોડ",
          "ફુલ ચક્કરની સંખ્યા અંદાજીત ૧૯ થી ૨૧",
          "સુગંધિત તેલની ટકાવારી આશરે ૧.૯ થી ૨.૬ ટકા",
          "ભુકીછારા રોગ સામે પ્રતિકારક જાત",
        ],
      },
      {
        image: "/Images/variyali/MANTAVYA 808 3.png",
        title: "મંતવ્ય 808",
        title2: "સંશોધીત વરીયાળી બીજ",
        titleColor: "#064f5a",
        content: [
          "ફેરરોપણી ના બદલે સીધા જ વાવેતર માટે ઉપયુક્ત",
          "રવી તથા ખરીફ ઋતુ માટે વાવણી લાયક જાત",
          "ખુલ્લો તથા જુસ્સાદાર છોડ તથા ૧૩૫ થી ૧૪૫ દિવસમાં પાકતી જાત",
          "૧૪૦ થી ૧૬૦ સે.મી. ઉંચો તથા ભરાવદાર દાણાવાળો છોડ",
          "ફુલ ચક્કરની સંખ્યા અંદાજીત ૧૮ થી ૨૦",
          "સુગંધિત તેલની ટકાવારી આશરે ૧.૮ થી ૨.૫ ટકા",
          "ભુકીછારા રોગ સામે પ્રતિકારક જાત",
        ],
      },
      {
        image: "/Images/variyali/MM-102 1.png",
        title: "એમએસ-૧૦૨",
        title2: "સંશોધીત વરીયાળી બીજ",
        titleColor: "#da7f2e",
        content: [
          "ફેરરોપણી ના બદલે સીધા જ વાવેતર માટે ઉપયુક્ત",
          "રવી તથા ખરીફ ઋતુ માટે વાવણી લાયક જાત",
          "ખુલ્લો તથા જુસ્સાદાર છોડ તથા ૧૩૫ થી ૧૪૫ દિવસમાં પાકતી જાત",
          "૧૩૫ થી ૧૫૫ સે.મી. ઉંચો તથા ભરાવદાર દાણાવાળો છોડ",
          "સુગંધિત તેલની ટકાવારી આશરે ૧.૬ થી ૨.૩ ટકા",
          "ભુકીછારા રોગ સામે પ્રતિકારક જાત",
        ],
      },
    ],
  },
  {
    id: 13,
    name: "ચણા",
    image: "/Images/chana/swara-3 1.png",
    bannerImage: "/Images/chana/chanabanner.png",
    bannerTitle: `ઉત્તમ ગુણવત્તાવાળા ચણાના બિયારણ,વધુ ઉપજ અને મજબૂત પાક માટે.`,
    headingTitle: "મંતવ્ય સીડ્સ ચણા ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/chana/chanagroup1.png",
      "/Images/chana/chanagroup2.png",
      "/Images/chana/chanagroup3.png",
      "/Images/chana/chanagroup4.png",
      "/Images/chana/chanagroup5.png",
    ],
    category: [
      {
        image: "/Images/chana/swara-3 1.png",
        title: "મંતવ્ય સ્વરા",
        title2: "સંશોધીત ચણા બીજ",
        titleColor: "#2a2886",
        content: [
          "પિયત તથા બિનપિયત વિસ્તાર માટે અનુકુળ જાત",
          "અંદાજીત ૧૦૦ થી ૧૧૦ દિવસમાં પાકતી જાત, વધારે ઉત્પાદન તથા દરેક વિસ્તાર માટે અનુકુળ",
          "આકર્ષક ભુરા રંગના તેમજ ખાવામાં ઉત્તમ દાણા",
          "પાણીના ભરાવથી થતી સમસ્યા સામે સહનશીલ જાત",
          "સુકારા તથા સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારક જાત",
          "૧૦૦ દાણાનું વજન અંદાજીત ૨૪ થી ૨૬ ગ્રામ",
          "અંદાજીત ૨૫ થી ૨૭ ક્વિંટલ પ્રતિ હેક્ટર ઉત્પાદન ધરાવતી જાત",
        ],
      },
      {
        image: "/Images/chana/mantavya_gujarat_5-removebg-preview 1.png",
        title: "મંતવ્ય-૫",
        title2: "સંશોધીત ચણા બીજ",
        titleColor: "#b71214",
        content: [
          "પિયત તથા બિનપિયત વિસ્તાર માટે અનુકુળ જાત",
          "આકર્ષક પીળા રંગના ખાવામાં ઉત્તમ નાના દાણા",
          "૯૦ થી ૧૦૦ દિવસમાં પાકતી જાત",
          "સુકારા તથા સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારક",
          "વધુ ઉત્પાદન તથા દરેક ક્ષેત્ર માટે ઉપયુક્ત",
          "૧૦૦ દાણાનું વજન લગભગ ૨૧ થી ૨૩ ગ્રામ",
        ],
      },
    ],
  },
  {
    id: 14,
    name: "ધાણા",
    image: "/Images/dhana/M-70 1.png",
    bannerImage: "/Images/dhana/dhanabanner.png",
    bannerTitle: `ભરપૂર સુગંધ અને ઊચ્ચ ઉપજ માટે શ્રેષ્ઠ ધાણાના બિયારણ.`,
    headingTitle: "મંતવ્ય સીડ્સ ધાણા ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/dhana/dhanagroup1.png",
      "/Images/dhana/dhanagroup2.png",
      "/Images/dhana/dhanagroup3.png",
      "/Images/dhana/dhanagroup4.png",
      "/Images/dhana/dhanagroup5.png",
    ],
    category: [
      {
        image: "/Images/dhana/M-70 1.png",
        title: "મંતવ્ય એમ 70",
        title2: "સંશોધીત ધાણા બીજ",
        titleColor: "#852b57",
        content: [
          "ખુલ્લો અને વધુ ડાળીયુક્ત છોડ",
          "છોડની ઉંચાઈ આશરે ૬૫ થી ૭૫ સે.મી.",
          "પાકવાના દિવસો આશરે ૧૦૦ થી ૧૧૫",
          "છોડ ઉપર ચક્કરની સંખ્યા આશરે ૧૬ થી ૨૦",
          "ભરાવદાર અને સુગંધિત દાણા",
          "છાસીયા અને સુકારા રોગ સામે પ્રતિકારક જાત",
          "સુગંધિત તેલની ટકાવારી આશરે ૦.૫ થી ૧.૦ ટકા સુધી",
        ],
      },
      {
        image: "/Images/dhana/mantavya king plus 1.png",
        title: "મંતવ્ય કિંગ પલ્સ",
        title2: "સંશોધીત ધાણા બીજ",
        titleColor: "#333365",
        content: [
          "છોડની ઉંચાઈ ૨૦ થી ૩૦ સે.મી",
          "પ્રથમ કાપણીની શરૂઆત ૩૫ થી ૪૦ દિવસે",
          "છોડ ઉખાડીને બંડલ બનાવીને વેચવા યોગ્ય",
          "ત્રણેય ઋતુમાં વાવણી યોગ્ય જાત",
          "પહોળા, ઘાટા લીલા તેમજ સુંગધિત પાન હોવાથી સારો બજાર ભાવ",
          "બોલ્ટીંગ રોગ સામે પ્રતિકારક જાત",
          "દાણા ફાડા હોવાથી ઓછો બીજ દર",
        ],
      },
    ],
  },
  {
    id: 15,
    name: "સોયાબીન",
    image: "/Images/soyabin/ms-726 3.png",
    bannerImage: "/Images/soyabin/soyabinbanner.png",
    bannerTitle: `ઉચ્ચ પ્રોટીન અને સારું ઉત્પાદન આપવા માટે ઉત્તમ સોયાબીન બિયારણ.`,
    headingTitle: "મંતવ્ય સીડ્સ સોયાબીન ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/soyabin/soyabingroup1.png",
      "/Images/soyabin/soyabingroup2.png",
      "/Images/soyabin/soyabingroup3.png",
      "/Images/soyabin/soyabingroup4.png",
      "/Images/soyabin/soyabingroup5.png",
      "/Images/soyabin/soyabingroup6.png",
    ],
    category: [
      {
        image: "/Images/soyabin/ms-726 3.png",
        title: "મંતવ્ય એમએસ-726",
        title2: "સંશોધીત સોયાબીન બીજ",
        titleColor: "#277a3a",
        content: [
          "૧૦૩ થી ૧૦૮ દિવસમાં પાકતી જાત",
          "પીળાશ પડતા સફેદ મધ્યમ કદના દાણા-મહત્તમ ઉગાવો",
          "છોડની ઉંચાઈ ૫૫ થી ૬૦ ઈંચ",
          "તેલ તેમજ પ્રોટિનની ઉંચી ટકાવારી હોઈ અન્ય જાતો કરતા ૯ થી ૧૨% સુધી વધુ બજારભાવ",
          "પિયત અને બિનપિયત તથા આંતરપાક માટે ઉપયુક્ત જાત",
          "બેક્ટેરીયલ બ્લાઈટ તથા અલ્ટરનેરીયા રોગ સામે સહનશીલ",
        ],
      },
      {
        image: "/Images/soyabin/MS-301 1.png",
        title: "મંતવ્ય એમએસ-301",
        title2: "સંશોધીત સોયાબીન બીજ",
        titleColor: "#773c2c",
        content: [
          "૯૫ થી ૧૦૫ દિવસમાં પાકતી જાત્",
          "પીળાશ પડતા સફેદ મોટા દાણા-મહત્તમ ઉગાવા",
          "બેક્ટેરીયલ બ્લાઈટ તથા અલ્ટરનેરીયા રોગ સામે સહનશીલ",
          "તેલ તેમજ પ્રોટિનની ઉંચી ટકાવારી હોઈ અન્ય જાતો કરતા ૧૦ થી ૧૨% સુધી વધુ બજારભાવ",
          "પિયત અને બિનપિયત તથા આંતરપાક માટે ઉપયુક્ત જાત",
        ],
      },
    ],
  },
  {
    id: 16,
    name: "ગમ ગુવાર",
    image: "/Images/gumguvar/ms-726 3.png",
    bannerImage: "/Images/soyabin/soyabinbanner.png",
    bannerTitle: `ઉચ્ચ પ્રોટીન અને સારું ઉત્પાદન આપવા માટે ઉત્તમ ગમ ગુવાર બિયારણ.`,
    headingTitle: "મંતવ્ય સીડ્સ ગમ ગુવાર ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/soyabin/soyabingroup1.png",
      "/Images/soyabin/soyabingroup2.png",
      "/Images/soyabin/soyabingroup3.png",
      "/Images/soyabin/soyabingroup4.png",
      "/Images/soyabin/soyabingroup5.png",
      "/Images/soyabin/soyabingroup6.png",
    ],
    category: [
      {
        image: "/Images/gumguvar/ms-726 3.png",
        title: "મંતવ્ય વિરાટ",
        title2: "સંશોધીત ગમ ગુવાર બીજ",
        titleColor: "#2BA14D",
        content: [
          "ડાળી વાળો, મધ્યમ ઉંચાઈવાળો છોડ",
          "મધ્યમ મોડી પાકતી જાત (૧૧૦ થી ૧૨૦ દિવસ)",
          "છોડની ઓછી ઊંચાઈનો (૯૦ થી ૧૦૦ સે.મી.)",
          "અર્ધ ખુલ્લી શાખાઓ, થડના નીચેથી નીકળે છે.",
          "મધ્યમ લંબાઇની સીંગો ઝૂમખામાં આવે છે, સીંગો પાકવા છતાં ખરતી નથી, છોડ પર સીંગો એકી સાથે",
          "દાણા ક્રીમી સફેદ રંગના, મધ્યમ કદના, દાણામાં ગમની માત્રા ૩૧ ટકા.",
          "કાલવણ (બેક્ટેરીયલ બ્લાઇટ) રોગ સામે પ્રતિકારક",
        ],
      },
      {
        image: "/Images/soyabin/MS-301 1.png",
        title: "મંતવ્ય વીર",
        title2: "સંશોધીત ગમ ગુવાર બીજ",
        titleColor: "#8D462D",
        content: [
          "વહેલી પાકતી જાત. (૮૫ થી ૯૫ દિવસ).",
          "મધ્યમ ઊંચાઈનો (૯૦ થી ૧૦૦ સે.મી.) છોડ.",
          "ડાળી વગરનો સોટીયો છોડ.",
          "મધ્યમ લંબાઇની ભરાવદાર સીંગો, નીચેના ભાગથી સીંગો ઝૂમખામાં આવે છે, છોડ પર સીંગો એકી સાથે પાકે છે અને પાકયા પછી છતાં ખરતી નથી.",
          "મધ્યમ કદના, ક્રીમી સફેદ રંગના દાણા, દાણામાં ગમની માત્રા ૩૨ ટકા.",
        ],
      },
    ],
  },
  {
    id: 17,
    name: "બાજરી",
    image: "/Images/bajari/MS 1010 3.png",
    bannerImage: "/Images/bajari/bajarigroup1.png",
    bannerTitle: `મંતવ્ય સીડ્સની બાજરી – વધુ ઉત્પાદન અને મજબૂત પાક માટે વિશ્વસનીય પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ બાજરી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/bajari/bajarigroup1.png",
      "/Images/bajari/bajarigroup2.png",
      "/Images/bajari/bajarigroup3.png",
      "/Images/bajari/bajarigroup4.png",
      "/Images/bajari/bajarigroup5.png",
      "/Images/bajari/bajarigroup6.png",
    ],
    category: [
      {
        image: "/Images/bajari/MS 1010 3.png",
        title: "મંતવ્ય 1010",
        title2: "સંશોધીત બાજરી બીજ",
        titleColor: "#656F32",
        content: [
          "જમીનના પ્રકાર પ્રમાણે ૭૮ થી ૮૨ દિવસના ગાળામાં વહેલી પાકતી જાત",
          "૭.૫ થી ૯ ફુટની ઉંચાઈ ધરાવતો વધુ ફૂટવાળો ઘાટા લીલા રંગનો છોડ",
          "કુતુલ (બાવા) અને અંગારીયા રોગ સામે પ્રતિકારક જાત",
          "દાણા કઠણ, મીઠા અને લીલો-સુકો સ્વાદિષ્ટ રસદાર ઘાસચારો",
          "વધુ અથવા ઓછો વરસાદ તેમજ ગરમી સામે પ્રતિકારક ક્ષમતા ધરાવતો છોડ",
          "ડુંડા ૨૮ થી ૩૦ સે.મી. લંબાઈવાળા મજબુત તથા વજનદાર",
        ],
      },
      {
        image: "/Images/bajari/mantavya 2020 1.png",
        title: "મંતવ્ય એમએસ-2020",
        title2: "સંશોધીત બાજરી બીજ",
        titleColor: "#008AC7",
        content: [
          "૭૫ થી ૮૦ દિવસમાં પાકતી જાત",
          "૬.૫ થી ૮ ફુટ ઉંચાઈવાળા છોડ",
          "કુતુલ (બાવા) અને અંગારીયા રોગ તથા ઉંચા તાપમાન સામે ટકી રહેવાની ક્ષમતા",
          "ચોમાસુ તેમજ ઉનાળુ બન્ને ઋતુ માટે વાવણી લાયક",
          "મધ્યમ મોટા અને સ્વાદિષ્ટ દાણા",
          "રેસા વગરનો લાંબો સમય તાજાે રહેતો ઘાસચારો",
        ],
      },
    ],
  },
  {
    id: 18,
    name: "મકાઈ",
    image:
      "/Images/makay/WhatsApp_Image_2023-12-18_at_5.03.04_PM-removebg-preview@3x 2.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ મકાઈ ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/makay/makaygroup1.png",
      "/Images/makay/makaygroup2.png",
      "/Images/makay/makaygroup3.png",
      "/Images/makay/makaygroup4.png",
      "/Images/makay/makaygroup5.png",
      "/Images/makay/makaygroup6.png",
    ],
    category: [
      {
        image:
          "/Images/makay/WhatsApp_Image_2023-12-18_at_5.03.04_PM-removebg-preview@3x 2.png",
        title: "મંતવ્ય 2626",
        title2: "સંશોધીત હા.મકાઈ બીજ",
        titleColor: "#4A1D69",
        content: [
          "ખરીફ અને રબી બન્ને ઋતુ માટે અનુકુળ જાત",
          "ખરીફ ઋતુમાં ૧૧૦ થી ૧૧૫ તથા રવિમાં ૧૨૦ થી ૧૨૫ દિવસે પાકતી જાત",
          "મુળ અને થડ મજબુત હોવાથી વાવઝોડા સામે રક્ષણ",
          "દરેક પ્રકારની જમીન માટે અનુકુળ જાત",
          "છોડની ઉંચાઈ લગભગ ૨૨૦ થી ૨૪૦ સે.મી.",
          "ગોળ નાના દાણાથી સંપૂર્ણ ભરેલા ડોડા",
          "સુકારા તેમજ પાંદડીયા રોગો સામે પ્રતિકારક જાત",
        ],
      },
      {
        image: "/Images/makay/3636 1.png",
        title: "મંતવ્ય 3636",
        title2: "સંશોધીત હા.મકાઈ બીજ",
        titleColor: "#DF5435",
        content: [
          "૯૫ થી ૧૧૦ દિવસમાં પાકતી અને ગરમી સામે સહનશીલ જાત",
          "ખરીફ તથા વર્ષા ઋતુ માટે વધુ અનુકુળ જાત અને વહેલી પાકતી તથા વધુ ચારો આપનારી જાત",
          "ઉભા પાન હોવાથી દરેક છોડ પર સરખો સુર્યપ્રકાશ જેથી વધુ ઉત્પાદન",
          "થડ અને મૂળ મજબુત હોવાથી વાવઝોડા સામે રક્ષણ",
          "વાવેતર અંતર બે છોડ વચ્ચે ૭ થી ૮ ઈંચ તથા બે લાઈન વચ્ચે ૨૨ થી ૨૬ ઈંચ",
        ],
      },
      {
        image: "/Images/makay/CAPTAIN 1.png",
        title: "મંતવ્ય કેપ્ટન",
        title2: "સંશોધીત હા.મકાઈ બીજ",
        titleColor: "#2D608F",
        content: [
          "પિયત-બિનપિયત વિસ્તાર માટે અનુકૂળ જાત",
          "આકર્ષક સફેદ રંગ ધરાવતાં મોટા કદના ઉત્તમ દાણા",
          "વહેલી પાકતી જાત",
          "સુકારા અને સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારકતા ધરાવતી જાત",
          "મુળ અને થડ મજબુત હોવાથી વાવઝોડા સામે રક્ષણ",
          "દરેક પ્રકારની જમીનને અનુકુળ જાત",
          "ઉત્તમ ગુણવત્તા તથા વધુ ઉત્પાદન આપતી જાત",
        ],
      },
      {
        image:
          "/Images/makay/WhatsApp_Image_2023-12-18_at_5.03.05_PM-removebg-preview 1.png",
        title: "મંતવ્ય એ ટુ ઝેડ",
        title2: "સંશોધીત હા.મકાઈ બીજ",
        titleColor: "#5F836C",
        content: [
          "અંદાજીત ૧૧૦ થી ૧૨૦ દિવસમાં પાકતી તથા ગરમી સામે સહનશીલ જાત",
          "ચોમાસું તથા શિયાળું બન્ને ઋતુ માટે વહેલી પાકતી તથા વધુ ઘાસચારો આપતી જાત",
          "અંદાજીત ૨૦૦ થી ૨૧૦ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "આકર્ષક સફેદ, ગોળ તથા મધ્યમ નાના કદના દાણા",
          "વાવેતર અંતર : છોડ થી છોડ - ૮ થી ૧૦ ઈંચ, લાઈન થી લાઈન - ૨૦ થી ૨૫ ઈંચ",
        ],
      },
    ],
  },
  {
    id: 19,
    name: "ડાંગર",
    image: "/Images/dangar/MS 3344 3.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ ડાંગર ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/makay/makaygroup1.png",
      "/Images/makay/makaygroup2.png",
      "/Images/makay/makaygroup3.png",
      "/Images/makay/makaygroup4.png",
      "/Images/makay/makaygroup5.png",
      "/Images/makay/makaygroup6.png",
    ],
    category: [
      {
        image: "/Images/dangar/MS 3344 3.png",
        title: "મંતવ્ય 3344",
        title2: "સંશોધીત ડાંગર બીજ",
        titleColor: "#AF3669",
        content: [
          "૧૨૦ થી ૧૩૦ દિવસે પાકતી ઉતમ જાત",
          "મધ્યમ આકર્ષક દાણો તથા ખૂબ વધારે ઉત્પાદન આપતી જાત",
          "૨૦ થી ૨૨ સે.મી. લાંબી કંટી, છોડની ઉંચાઈ ૭૫ થી ૮૫ સે.મી.",
          "રોગો તથા જીવાત સામે ખૂબ જ પ્રતિકારક શક્તિ ધરાવતી જાત",
          "ડાંગર પકવતા બધા વિસ્તાર માટે અનુકુળ તથા ૧૨ થી ૧૬ કંટીઓ ધરાવતી જાત",
        ],
      },
      {
        image: "/Images/dangar/BADSHAH 1.png",
        title: "મંતવ્ય બાદશાહ",
        title2: "સંશોધીત ડાંગર બીજ",
        titleColor: "#318573",
        content: [
          "૧૧૫ થી ૧૨૫ દિવસે પાકતી ઉતમ સંકર જાત",
          "૨૦ થી ૨૫ સે.મી. લાંબી કંટી, છોડની ઉંચાઈ ૮૫ થી ૯૦ સે.મી.",
          "રોગો તથા જીવાત સામે ખૂબ જ પ્રતિકારક શક્તિ ધરાવતી જાત",
          "ખાવામાં સારી તથા મીલીંગ ટકાવારી સારી હોવાથી બજાર ભાવ ઊંચો મળે છે.",
          "મોટો આકર્ષક દાણો તથા ખૂબ વધારે ઉત્પાદન આપતી જાત",
        ],
      },
    ],
  },
  {
    id: 20,
    name: "મેથી",
    image: "/Images/methi/mantavya rudra 1.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ મેથી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/methi/methigroup1.png",
      "/Images/methi/methigroup2.png",
      "/Images/methi/methigroup3.png",
      "/Images/methi/methigroup4.png",
      "/Images/methi/methigroup5.png",
    ],
    category: [
      {
        image: "/Images/methi/mantavya rudra 1.png",
        title: "મંતવ્ય રૂદ્રા",
        title2: "સંશોધીત મેથી બીજ",
        titleColor: "#FE2728",
        content: [
          "પાન પહોળા અને સુગંધિત હોય છે.",
          "જાત ૫ થી ૬ વખત કાપણી કરી શકાય છે.",
          "શાકભાજી માટે સૌથી વધુ પસંદ કરવામાં આવતી જાત.",
          "પાનને સૂકવીને પણ વાપરી શકાય છે.",
          "વાવણી : જુલાઈથી ફેબ્રુઆરી દરમિયાન થાય છે.",
        ],
      },
    ],
  },
  {
    id: 21,
    name: "ડુંગળી",
    image: "/Images/methi/mantavya rudra 1.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ ડુંગળી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/dungali/dungaligroup1.png",
      "/Images/dungali/dungaligroup2.png",
      "/Images/dungali/dungaligroup3.png",
      "/Images/dungali/dungaligroup4.png",
      "/Images/dungali/dungaligroup5.png",
      "/Images/dungali/dungaligroup6.png",
    ],
    category: [
      {
        image: "/Images/methi/mantavya rudra 1.png",
        title: "મંતવ્ય રેડ બોલ",
        title2: "સંશોધીત ડુંગળી બીજ",
        titleColor: "#656F32",
        content: [
          "વાવેતર સમય : ચોમાસું જુનથી ઓક્ટોબર મહિના સુધી વાવી શકાય તેવી જાત",
          "આકર્ષક ચમકીલો ઘાટ્ટો લાલ રંગ",
          "આકાર : ગોળાકાર",
          "સાઈઝ (કદ) : ૫૦ થી ૬૦ એમ.એમ.",
          "વિશેષતા : ફેરરોપણી બાદ ૭૫-૮૫ દિવસે પાકતી જાત સારો બજાર ભાવ અને વિકાસ માટે ઉત્તમ જાત",
        ],
      },
      {
        image: "/Images/dungali/mantavya safal 1.png",
        title: "મંતવ્ય સફલ",
        title2: "સંશોધીત ડુંગળી બીજ",
        titleColor: "#B71510",
        content: [
          "વાવેતર : જુન થી સપ્ટેમ્બર મહિના સુધી વાવી શકાય તેવી જાત",
          "કલર : આકર્ષક ચમકીલો લાલ રંગ",
          "આકાર : ગોળાકાર",
          "સાાઈઝ (કદ) : ૫૫ થી ૬૦ એમ.એમ",
          "વિશેષત : ફેર રોપણી બાદ ૮૦-૯૦ દિવસમાં પાકતી જાત સારો બજાર ભા અને નિકાસ માટે ની ઉત્તમ જાત",
        ],
      },
    ],
  },
  {
    id: 22,
    name: "રજકા",
    image: "/Images/rajka/MS-01 2.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ રજકા ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/dungali/dungaligroup1.png",
      "/Images/dungali/dungaligroup2.png",
      "/Images/dungali/dungaligroup3.png",
      "/Images/dungali/dungaligroup4.png",
      "/Images/dungali/dungaligroup5.png",
      "/Images/dungali/dungaligroup6.png",
    ],
    category: [
      {
        image: "/Images/rajka/MS-01 2.png",
        title: "એમએસ-01",
        title2: "સંશોધીત રજકા બીજ",
        titleColor: "#54502A",
        content: [
          "છોડની ઉંચાઈ ૯૦ થી ૧૦૦ સે.મી.",
          "છોડમાં ૨૫ થી ૩૦ પીલાની સંખ્યા.",
          "પ્રથમ કાપણી ૫૫ દિવસ પછી.",
          "અમરવેલ રહિત ઘાસચારા માટે ઉત્તમ જાત.",
          "પશુઓ માટે ઉચ્ચ ગુણવત્તા યુક્ત સ્વાદિષ્ટ ઘાસચારો.",
          "એક વર્ષાળું જાત.",
        ],
      },
      {
        image: "/Images/rajka/ms-03 1.png",
        title: "એમએસ-03",
        title2: "સંશોધીત રજકા બીજ",
        titleColor: "#28806D",
        content: [
          "અંદાજીત ૯૫ થી ૧૦૫ સે.મી. ઉંચાઈ ધરાવતો છોડ",
          "અંદાજીત ૫૦ થી ૫૫ દિવસે પ્રથમ કાપણી",
          "મહત્તમ કાપણી માટે તથા ત્રણ સાલ સુધી ચાલતી જાત",
          "અમરવેલ રહિત જાત",
          "ઘાટા લીલા પાન તથા ખાવામાં સ્વાદિષ્ટ ઘાસચારો",
        ],
      },
      {
        image: "/Images/rajka/MS AMUL 2.png",
        title: "મંતવ્ય અમુલ",
        title2: "સંશોધીત રજકા બીજ",
        titleColor: "#7B364D",
        content: [
          "૬ ઈંચ જમીનના ઉપરથી કાપતાં ૪ થી ૬ કાપણી માટે ઉપયુક્ત જાત",
          "પહોળા અને ઘાટા લીલા રંગના પાંદડા",
          "છોડની ઉંચાઈ આશરે ૫ થી ૬ ફુટ",
          "રેસાવિહિન છોડ હોવાથી ખંજવાળથી મુક્તિ",
          "વર્ષા તેમજ ઉનાળું વાવેતર માટે ઉત્તમ જાત",
          "પ્રોટીન માત્રા ૮ થી ૧૦ ટકા તથા પશુ માટે ખાવામાં નરમ અને સ્વાદિષ્ટ ઘાસચારો",
        ],
      },
      {
        image: "/Images/rajka/atulya 1.png",
        title: "મંતવ્ય અતુલ્ય",
        title2: "સંશોધીત (મલ્ટીકટ) રજકો બીજ",
        titleColor: "#574B3D",
        content: [
            "૬ ઈંચ જમીનના ઉપરથી કાપતાં ૬ થી ૮ કાપણી માટે ઉપયુક્ત જાત",
            "પહોળા અને ઘાટા લીલા રંગના પાંદડા",
            "છોડની ઉંચાઈ આશરે ૭ થી ૯ ફુટ",
            "રેસાવિહિન છોડ હોવાથી ખંજવાળથી મુક્તિ",
            "વર્ષા તેમજ ઉનાળું વાવેતર માટે ઉત્તમ જાત",
            "પ્રોટીન માત્રા ૮ થી ૧૦ ટકા તથા પશુ માટે ખાવામાં નરમ અને સ્વાદિષ્ટ ઘાસચારો",
            "ખાવામાં નરમ અને સ્વાદિષ્ટ ઘાસચારો"
        ],
      },
    ],
  },
  {
    id: 23,
    name: "એસએસજી",
    image: "/Images/ssg/MS kesar 3.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ એસએસજી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/dungali/dungaligroup1.png",
      "/Images/dungali/dungaligroup2.png",
      "/Images/dungali/dungaligroup3.png",
      "/Images/dungali/dungaligroup4.png",
      "/Images/dungali/dungaligroup5.png",
      "/Images/dungali/dungaligroup6.png",
    ],
    category: [
      {
        image: "/Images/ssg/MS kesar 3.png",
        title: "મંતવ્ય કેસર",
        title2: "સંશોધીત એસએસજી (રેડ) બીજ",
        titleColor: "#656F32",
        content: [
            "પિયત તથા બિનપિયત વિસ્તાર માટે અનુકુળ જાત",
            "મધ્યમ લાલ રંગના દાણા",
            "૧૦૦ થી ૧૦૫ દિવસમાં પાકતી જાત",
            "સુકારા તથા સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારક",
            "કાપણી સુધી લીલો ઘાસચારો",
            "વધુ ઉત્પાદન તથા દરેક ક્ષેત્ર માટે ઉપયુક્ત"
        ],
      },
      {
        image: "/Images/ssg/ujala 1.png",
        title: "મંતવ્ય ઉજાલા",
        title2: "સંશોધીત એસએસજી (વ્હાઈટ) બીજ",
        titleColor: "#008AC7",
        content: [
            "પિયત તથા બિનપિયત વિસ્તાર માટે અનુકુળ જાત",
            "મધ્યમ સફેદ રંગના દાણા",
            "૧૦૫ થી ૧૧૦ દિવસમાં પાકતી જાત",
            "સુકારા તથા સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારક",
            "વધુ ઉત્પાદન તથા દરેક ક્ષેત્ર માટે ઉપયુક્ત",
            "ઘાસચારા તથા દાણા માટેની ઉત્તમ જાત"
        ],
      },
    ],
  },
  {
    id: 24,
    name: "ચોળી",
    image: "/Images/choli/MS power 2.png",
    bannerImage: "/Images/makay/makaygroup5.png",
    bannerTitle: `મંતવ્ય સીડ્સની મકાઈ – ઊચ્ચ ગુણવત્તાવાળું બિયારણ, વધુ ઉપજ માટે શ્રેષ્ઠ પસંદગી.`,
    headingTitle: "મંતવ્ય સીડ્સ ચોળી ના બધાજ બિયારણ",
    imageGroup: [
      "/Images/methi/methigroup1.png",
      "/Images/methi/methigroup2.png",
      "/Images/methi/methigroup3.png",
      "/Images/methi/methigroup4.png",
      "/Images/methi/methigroup5.png",
    ],
    category: [
      {
        image: "/Images/choli/MS power 2.png",
        title: "મંતવ્ય ઉજાલા",
        title2: "સંશોધીત ચોળી બીજ",
        titleColor: "#FE2728",
        content: [
            "પિયત તથા બિનપિયત વિસ્તાર માટે અનુકુળ જાત",
            "મધ્યમ સફેદ રંગના દાણા",
            "૧૦૫ થી ૧૧૦ દિવસમાં પાકતી જાત",
            "સુકારા તથા સ્ટન્ટ વાઈરસ સામે મધ્યમ પ્રતિકારક",
            "વધુ ઉત્પાદન તથા દરેક ક્ષેત્ર માટે ઉપયુક્ત",
            "ઘાસચારા તથા દાણા માટેની ઉત્તમ જાત"
        ],
      },
    ],
  },
  // Add more products as needed
];
